<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <div style="font-size: 80%; font-weight: 600; color: rgba(0, 0, 0, 0.7)">
        到款记录<text style="color: #f00; font-weight: 500; margin-left: 10px"
          >注：请在表格第一列选择一条到款记录作为合并后的主体！</text
        >
      </div>
      <el-radio-group
        v-model="state.bank_received_id"
        style="
          flex: 1;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          margin-top: 5px;
        "
      >
        <el-table
          :data="state.tableData"
          v-loading="!Array.isArray(state.tableData)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          ref="tableDom"
        >
          <el-table-column width="55" label="#" fixed>
            <template #default="{ row }">
              <el-radio :value="row.id"></el-radio>
            </template>
          </el-table-column>
          <el-table-column
            label="到款时间"
            prop="received_time"
            sortable="received_time"
            width="120"
            :formatter="$tab_TextFormat"
            fixed
          />
          <el-table-column
            label="付款人"
            prop="payment_name"
            :formatter="$tab_TextFormat"
            :min-width="160"
          />
          <el-table-column
            label="金额"
            prop="received_amount"
            align="right"
            :formatter="$tab_PriceFormat"
            min-width="140"
          />
          <el-table-column
            label="实际到账金额/手续费"
            align="right"
            :formatter="
              (row) =>
                $tab_GroupFormat(
                  $priceFormat(row.real_received_amount),
                  $priceFormat(row.service_fee)
                )
            "
            min-width="160"
          />
          <el-table-column
            label="已认领/未认领金额"
            min-width="160"
            align="right"
          >
            <template #default="{ row }">
              <div style="display: flex; justify-content: flex-end">
                <c_tabgroup
                  :value1="$priceFormat(row.collected_amount)"
                  style="
                    align-items: flex-end;
                    display: flex;
                    flex-direction: column;
                  "
                >
                  <template #bottom>
                    <c_money
                      style="font-weight: 600"
                      :value="row.uncollected_amount"
                    />
                  </template>
                </c_tabgroup>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态/ID" sortable="id" width="120">
            <template #default="{ row }">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  width: fit-content;
                "
              >
                <component
                  :is="
                    $statusFormat2(
                      'bankReceived_collected_status',
                      row.collected_status
                    )
                  "
                />
                <text
                  style="
                    color: #a2a2a2;
                    font-size: var(--tab-group-second-font-size);
                    text-align: center;
                  "
                >
                  {{ row.id }}
                </text>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="匹配客户"
            prop="customer_name"
            width="200"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="到账银行"
            :formatter="
              (row) =>
                $tab_GroupFormat(
                  row.bank_account?.account,
                  row.bank_account?.opening_bank || ''
                )
            "
            min-width="220"
          />
          <el-table-column
            label="付款银行"
            :formatter="
              (row) =>
                $tab_GroupFormat(row.payment_account, row.payment_bank || '')
            "
            min-width="220"
          />
          <el-table-column label="摘要信息/认领明细" min-width="400">
            <template #default="{ row }">
              <div>
                <ul>
                  {{
                    row.customer_name || "-"
                  }}
                </ul>
                <ul
                  v-if="row.collected_amount_detail?.collected"
                  style="
                    color: #a2a2a2;
                    font-size: var(--tab-group-second-font-size);
                  "
                  v-html="
                    Object.keys(row.collected_amount_detail?.collected)
                      .map(
                        (key) =>
                          `${key}: <text style='color:#ffa500;margin-right:5px'>${$priceFormat(
                            row.collected_amount_detail?.collected[key]
                          )}</text>`
                      )
                      .join(' ')
                  "
                ></ul>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-radio-group>
      <div style="margin-top: 10px">
        <ul style="font-size: 80%; font-weight: 600; color: rgba(0, 0, 0, 0.7)">
          合并说明
        </ul>
        <el-input
          type="textarea"
          v-model="state.remark"
          placeholder="合并说明"
          :autosize="{ minRows: 2 }"
        />
      </div>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交合并申请</el-button>
      <el-button type="info" @click="onClose">取消</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { bankcollected_merge } from "@/http/bankcollected";
import { ElMessage, ElMessageBox } from "element-plus";
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const state = reactive({});
    onMounted(() => {
      state.tableData = props.data;

      const item = props.data.find((w) => w.customer_id);
      if (item) {
        state.disabledChangeCustomer = true;
        state.customer_id = item.customer_id;
      }
    });

    const onClose = () => {
      emit("close");
    };

    const onSubmit = () => {
      if (!state.bank_received_id) {
        ElMessage({
          type: "warning",
          grouping: true,
          message: `请在表格第一列选择一条到款记录作为合并后的主体！`,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您本次共选择了<strong style='color:#f00'>${state.tableData?.length}</strong>条到款记录，是否提交合并申请？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "提交合并",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        bankcollected_merge({
          bank_received_id: state.bank_received_id,
          bank_received_ids: state.tableData.map((m) => m.id).join(","),
          remark: state.remark,
        }).then((res) => {
          ElMessage({
            type: "success",
            message: res.data.msg,
          });

          emit("confirm");
        });
      });
    };
    return { state, onClose, onSubmit };
  },
};
</script>
<style scoped lang="less"></style>
